export default "__VITE_ASSET__Dc46_wJK__"